




















































import {Vue, Component, Watch, Prop} from "vue-property-decorator";
import StepperTooltip from "@/components/StepperTooltip.vue";
import {
    FullSurveyType,
    SurveyTabType,
    SurveySectionType,
    SurveyAdditionalInfoSectionType
} from "@/types/surveyTab.type";
import {
    SurveyTabCollectionType,
    ProgressIconsListType
} from "@/types/surveyComponent.type";

@Component({
    components: {StepperTooltip}
})
export default class SurveyStepper extends Vue {
    @Prop() currentTab!: number;
    @Prop() surveyTabs!: SurveyTabCollectionType;

    graphWidth = 200;

    resetData: FullSurveyType = require("@/assets/data/blankform.json");
    progressIcons: ProgressIconsListType = {
        completedIcon: {
            icon: "mdi-check",
            color: "green",
            text: "Section Complete"
        },
        inProgressIcon: {
            icon: "mdi-cog",
            color: "lightBlue",
            text: "Section In Progress"
        },
        notStartedIcon: {
            icon: "mdi-circle-small",
            color: "grey",
            text: "Not Started"
        }
    };

    mounted() {
        this.setGraphWidth();
        window.addEventListener("resize", () => {
            this.setGraphWidth();
        });
    }

    $refs!: {
        cardContainer: HTMLDivElement;
    };

    setGraphWidth() {
        if (
            this.$refs.cardContainer != undefined &&
            this.$refs.cardContainer.clientWidth != undefined
        ) {
            this.graphWidth = this.$refs.cardContainer.clientWidth - 90;
        }
    }

    setTab(step: number) {
        this.$emit("setTab", step);
    }

    getIcon(step: number) {
        const standardQuestions = [
            "scaleQuestions",
            "accessQuestions",
            "authQuestions",
            "hardwareQuestions",
            "softwareQuestions",
            "ddosQuestions"
        ];

        let error = false;
        let tabData: SurveyTabType = this.voterRegistrationQuestions;
        let visited;
        let originalData: SurveyTabType = this.resetData
            .voterRegistrationQuestions;
        if (step === 1) {
            tabData = this.voterRegistrationQuestions;
            visited = this.voterRegistrationVisited;
            originalData = this.resetData.voterRegistrationQuestions;
        } else if (step === 2) {
            tabData = this.pollbookPrepQuestions;
            visited = this.pollbookPrepVisited;
            originalData = this.resetData.pollbookPrepQuestions;
        } else if (step === 3) {
            tabData = this.pollbookUseQuestions;
            visited = this.pollbookUseVisited;
            originalData = this.resetData.pollbookUseQuestions;
        } else if (step === 4) {
            tabData = this.ballotPrepQuestions;
            visited = this.ballotPrepVisited;
            originalData = this.resetData.ballotPrepQuestions;
        } else if (step === 5) {
            tabData = this.votingMachinePrepQuestions;
            visited = this.votingMachinePrepVisited;
            originalData = this.resetData.votingMachinePrepQuestions;
        } else if (step === 6) {
            tabData = this.votingMachineUseQuestions;
            visited = this.votingMachineUseVisited;
            originalData = this.resetData.votingMachineUseQuestions;
        } else if (step === 7) {
            tabData = this.tabulationPrepQuestions;
            visited = this.tabulationPrepVisited;
            originalData = this.resetData.tabulationPrepQuestions;
        } else if (step === 8) {
            tabData = this.precinctTabulationQuestions;
            visited = this.precinctTabulationVisited;
            originalData = this.resetData.precinctTabulationQuestions;
        } else if (step === 9) {
            tabData = this.centralTabulationQuestions;
            visited = this.centralTabulationVisited;
            originalData = this.resetData.centralTabulationQuestions;
        } else if (step === 10) {
            tabData = this.aggregationQuestions;
            visited = this.aggregationVisited;
            originalData = this.resetData.aggregationQuestions;
        } else if (step === 11) {
            tabData = this.websiteQuestions;
            visited = this.websiteVisited;
            originalData = this.resetData.websiteQuestions;
        } else {
            error = true;
        }
        if (
            error === false &&
            step === this.currentTab &&
            tabData.scaleQuestions.complete &&
            tabData.accessQuestions.complete &&
            tabData.authQuestions.complete &&
            tabData.hardwareQuestions.complete &&
            tabData.softwareQuestions.complete &&
            tabData.ddosQuestions.complete
        ) {
            return {
                icon: "mdi-arrow-down-drop-circle-outline",
                color: "blue",
                complete: true
            };
        } else if (step === this.currentTab) {
            return {
                icon: "mdi-arrow-down-drop-circle-outline",
                color: "blue",
                complete: false
            };
        } else if (
            tabData.scaleQuestions.complete &&
            tabData.accessQuestions.complete &&
            tabData.authQuestions.complete &&
            tabData.hardwareQuestions.complete &&
            tabData.softwareQuestions.complete &&
            tabData.ddosQuestions.complete
        ) {
            return {
                icon: this.progressIcons.completedIcon.icon,
                color: this.progressIcons.completedIcon.color,
                complete: true
            };
        } else if (visited) {
            let changed = false;
            //iterate through standard questions
            for (const questionKey in tabData) {
                if (
                    standardQuestions.includes(
                        questionKey as keyof SurveyTabType
                    )
                ) {
                    for (const key in tabData[
                        questionKey as keyof SurveyTabType
                    ]!.questions) {
                        if (
                            (tabData[
                                questionKey as keyof SurveyTabType
                            ] as SurveySectionType).questions[key].userInput
                                .answer !=
                                (originalData[
                                    questionKey as keyof SurveyTabType
                                ] as SurveySectionType).questions[key].userInput
                                    .answer ||
                            (tabData[
                                questionKey as keyof SurveyTabType
                            ] as SurveySectionType).questions[key].userInput
                                .bookmarked != false ||
                            (tabData[
                                questionKey as keyof SurveyTabType
                            ] as SurveySectionType).questions[key].userInput
                                .comments != null
                        ) {
                            changed = true;
                        }
                    }
                }
            }

            // iterate through importance questions
            Object.keys(tabData.importanceQuestions.questions).forEach(key => {
                if (
                    tabData.importanceQuestions.questions[key].userInput
                        .userValue !=
                        tabData.importanceQuestions.questions[key].default ||
                    tabData.importanceQuestions.questions[key].userInput
                        .bookmarked != false ||
                    tabData.importanceQuestions.questions[key].userInput
                        .comments != null
                ) {
                    changed = true;
                }
            });

            // iterate through comment questions
            if (step !== 3 && step !== 9 && step !== 10 && step !== 11) {
                Object.keys(
                    (tabData.additionalInformation as SurveyAdditionalInfoSectionType)
                        .questions
                ).forEach(key => {
                    let originalValues = false;
                    if (
                        ((tabData.additionalInformation as SurveyAdditionalInfoSectionType)
                            .questions[key].userInput.answer == null ||
                            (tabData.additionalInformation as SurveyAdditionalInfoSectionType)
                                .questions[key].userInput.answer == "") &&
                        (tabData.additionalInformation as SurveyAdditionalInfoSectionType)
                            .questions[key].userInput.bookmarked == false
                    ) {
                        originalValues = true;
                    }
                    if (!originalValues) {
                        changed = true;
                    }
                });
            }

            if (changed) {
                return {
                    icon: this.progressIcons.inProgressIcon.icon,
                    color: this.progressIcons.inProgressIcon.color,
                    complete: false
                };
            } else {
                return {
                    icon: this.progressIcons.notStartedIcon.icon,
                    color: this.progressIcons.notStartedIcon.color,
                    complete: false
                };
            }
        } else
            return {
                icon: this.progressIcons.notStartedIcon.icon,
                color: this.progressIcons.notStartedIcon.color,
                complete: false
            };
    }

    get enabledTabs(): SurveyTabType[] {
        const enabledTabs: SurveyTabType[] = [];
        for (const [key, value] of Object.entries(this.surveyTabs)) {
            if (!value.hideStep) {
                enabledTabs.push(value);
            }
        }
        return enabledTabs;
    }

    get completed() {
        let complete = 0;
        for (const key in this.surveyTabs) {
            if (this.getIcon(this.surveyTabs[key].step).complete) {
                complete++;
            }
        }
        return complete;
    }

    get progressValue() {
        return (this.completed / this.enabledTabs.length) * 100;
    }

    // --  Getters --
    // tab-data
    get voterRegistrationQuestions(): SurveyTabType {
        return this.$store.getters.voterRegistrationQuestions;
    }
    get pollbookPrepQuestions(): SurveyTabType {
        return this.$store.getters.pollbookPrepQuestions;
    }
    get pollbookUseQuestions(): SurveyTabType {
        return this.$store.getters.pollbookUseQuestions;
    }
    get ballotPrepQuestions(): SurveyTabType {
        return this.$store.getters.ballotPrepQuestions;
    }
    get votingMachinePrepQuestions(): SurveyTabType {
        return this.$store.getters.votingMachinePrepQuestions;
    }
    get votingMachineUseQuestions(): SurveyTabType {
        return this.$store.getters.votingMachineUseQuestions;
    }
    get tabulationPrepQuestions(): SurveyTabType {
        return this.$store.getters.tabulationPrepQuestions;
    }
    get precinctTabulationQuestions(): SurveyTabType {
        return this.$store.getters.precinctTabulationQuestions;
    }
    get centralTabulationQuestions(): SurveyTabType {
        return this.$store.getters.centralTabulationQuestions;
    }
    get aggregationQuestions(): SurveyTabType {
        return this.$store.getters.aggregationQuestions;
    }
    get websiteQuestions(): SurveyTabType {
        return this.$store.getters.websiteQuestions;
    }
    // section-visited info
    get voterRegistrationVisited() {
        return this.$store.getters.voterRegistrationVisited;
    }
    get pollbookPrepVisited() {
        return this.$store.getters.pollbookPrepVisited;
    }
    get pollbookUseVisited() {
        return this.$store.getters.pollbookUseVisited;
    }
    get ballotPrepVisited() {
        return this.$store.getters.ballotPrepVisited;
    }
    get votingMachinePrepVisited() {
        return this.$store.getters.votingMachinePrepVisited;
    }
    get votingMachineUseVisited() {
        return this.$store.getters.votingMachineUseVisited;
    }
    get tabulationPrepVisited() {
        return this.$store.getters.tabulationPrepVisited;
    }
    get precinctTabulationVisited() {
        return this.$store.getters.precinctTabulationVisited;
    }
    get centralTabulationVisited() {
        return this.$store.getters.centralTabulationVisited;
    }
    get aggregationVisited() {
        return this.$store.getters.aggregationVisited;
    }
    get websiteVisited() {
        return this.$store.getters.websiteVisited;
    }
}
